import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

export default function ThankYouPage() {

    let navigate = useNavigate();
    useEffect(() => {
        const goToStartCoding = () => {
            navigate("/startCoding");
        }
        const searchParams = new URLSearchParams(window.location.search)
        const sessionId = searchParams.get("session")
        if (sessionId == null) {
            goToStartCoding();
            return
        }
        fetch("/api/v1/checkout-session-info?session=" + sessionId).then(response => {
            if (response.ok) {
                response.json().then(data => {
                    if (data.status === "success") {
                        try {
                            gtag('event', 'purchase', data.event)
                        } catch (e) {
                            console.error(e)
                        }
                        setTimeout(() => {
                            goToStartCoding();
                        }, 200)
                    } else {
                        goToStartCoding();
                    }
                }).catch((e) => {
                    console.error(e)
                    goToStartCoding();
                })
            } else {
                goToStartCoding();
            }
        }).catch((e) => {
            console.error(e)
            goToStartCoding();
        })
    }, [navigate]);
    return null
}